var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7cccf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62b7e3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.333333h16v6.095238h-16z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v5.333333h-16z",
    fill: "url(#a)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381 5.33333333c0 .68680418.36687251 1.31013328.94992208 1.64844123.18197868.10559108.41510003.0436667.5206911-.13831198.10559108-.18197868.0436667-.41510003-.13831197-.52069111-.35045346-.20334668-.57039645-.57703742-.57039645-.98943814 0-.21039418-.1705582-.38095238-.38095238-.38095238-.21039419 0-.38095238.1705582-.38095238.38095238zm2.92993165 1.60557368c.54345836-.3475795.87959215-.94808961.87959215-1.60557368 0-.21039418-.17055817-.38095238-.38095238-.38095238s-.38095238.1705582-.38095238.38095238c0 .39485859-.20143756.75473097-.52819901.96371773-.17724365.11335965-.22903184.34894016-.11567215.52618379.11335962.17724363.34894012.22903182.52618377.11567216z",
    fill: "#445f42",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 4.952381,
    fill: "#d89f3d",
    mask: "url(#d)",
    rx: 1,
    ry: 1.142857
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/SM.76dc93457b4a9271a93a2fb43c81417c.svg";
export { ForwardRef as ReactComponent };